<template>
  <div>
    <InternetAuctionsList
      v-if="isInternetType"/>
    <FinishedAuctionsCatalogArtworksList
      v-else/> 
  </div>
</template>

<script>
  import FinishedAuctionsCatalogArtworksList from './artworks/list';
  import InternetAuctionsList from './internet/auctions/list';

  export default {
    name: 'Artworks',
    components: {
      FinishedAuctionsCatalogArtworksList,
      InternetAuctionsList,
    },
    computed: {
      isInternetType() {
        return this.$route.params.auctionType === 'internet';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/artworks.vue?b6b67984